import { render, staticRenderFns } from "./IUJPTL.vue?vue&type=template&id=2f0d6f34&"
import script from "./IUJPTL.vue?vue&type=script&lang=js&"
export * from "./IUJPTL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports